import * as React from 'react';
import classNames from 'classnames';

import { ILinkProps } from './types';

import * as styles from './Link.css';

export const Link = React.forwardRef(function Link(props: ILinkProps, ref: React.Ref<HTMLAnchorElement>) {
  const { children, theme, ...rest } = props;

  return (
    <a
      className={classNames(
        styles['link'],
        theme === 'primary' && styles['primary'],
        theme === 'accent' && styles['accent'],
        theme === 'light' && styles['light'],
      )}
      {...rest}
      rel="noopener noreferrer"
      ref={ref}
    >
      {children}
    </a>
  );
});
